import type { NorthStarRecord } from '../services/api'

/**
 * Whether the client has approved the North Star that is live now. The
 * approval names the version it was given against; a save that changes the
 * content moves the version on without it, and unpublishing removes it. The
 * backend lambdas apply the same rule.
 */
export function isNorthStarClientApproved(
  record: Pick<NorthStarRecord, 'isPublished' | 'version' | 'clientApprovedVersion'> | null | undefined
): boolean {
  return (
    record?.isPublished === true &&
    record.clientApprovedVersion != null &&
    record.clientApprovedVersion === record.version
  )
}
